import axios from 'axios';
import { createContext, useContext } from 'react';
import env from '../../config/env';

const axiosContext = createContext(null);

const api = axios.create({
  baseURL: `${env.baseUrlApi}`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export function ProvideAxios({ children }) {
  const client = useProvideAxios();

  return <axiosContext.Provider value={client}>{children}</axiosContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAxios() {
  return useContext(axiosContext);
}

function useProvideAxios() {
  const request = async (method, url, data, config = {}) => {
    try {
      return await api.request({
        method,
        url,
        data,
        ...config,
      });
    } catch (error) {
      console.error(
        `API ${method.toUpperCase()} ${url} failed:`,
        error.response?.data || error.message
      );

      throw error;
    }
  };

  return {
    get: (url, config) => request('get', url, undefined, config),
    post: (url, data, config) => request('post', url, data, config),
    put: (url, data, config) => request('put', url, data, config),
    patch: (url, data, config) => request('patch', url, data, config),
    delete: (url, config) => request('delete', url, undefined, config),
  };
}
